"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3669],{

/***/ 2597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Accordion; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(37946);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react-animate-height/lib/AnimateHeight.js
var AnimateHeight = __webpack_require__(68133);
;// CONCATENATED MODULE: ./components/Collapse.tsx





var Collapse = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var isOpen = _param.isOpen, _animateOpacity = _param.animateOpacity, animateOpacity = _animateOpacity === void 0 ? true : _animateOpacity, onAnimationStart = _param.onAnimationStart, onAnimationEnd = _param.onAnimationEnd, duration = _param.duration, _easing = _param.easing, easing = _easing === void 0 ? "ease" : _easing, _startingHeight = _param.startingHeight, startingHeight = _startingHeight === void 0 ? 0 : _startingHeight, _endingHeight = _param.endingHeight, endingHeight = _endingHeight === void 0 ? "auto" : _endingHeight, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "isOpen",
        "animateOpacity",
        "onAnimationStart",
        "onAnimationEnd",
        "duration",
        "easing",
        "startingHeight",
        "endingHeight"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimateHeight/* default */.Z, {
        duration: duration,
        easing: easing,
        animateOpacity: animateOpacity,
        height: isOpen ? endingHeight : startingHeight,
        applyInlineTransitions: false,
        onAnimationStart: onAnimationStart,
        onAnimationEnd: onAnimationEnd,
        style: {
            transition: "height .3s ease,opacity .3s ease-in-out,transform .3s ease-in-out",
            backfaceVisibility: "hidden"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
            ref: ref
        }, rest))
    });
});
/* harmony default export */ var components_Collapse = (Collapse);

// EXTERNAL MODULE: ./components/RichText.tsx
var RichText = __webpack_require__(73017);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(13274);
;// CONCATENATED MODULE: ./components/Accordion.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 2rem;\n  width: 90%;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 2.4rem;\n  transition: transform 0.3s;\n  transform: rotateZ(",
        "deg);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 2.5rem;\n  font-size: 1.6rem;\n  font-weight: normal;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 1.2rem 1.5rem;\n  background: #fff;\n  box-shadow: var(--shadow-md);\n  cursor: pointer;\n  border-radius: 0.6rem;\n  transition: opacity 0.2s;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






function Accordion(param) {
    var title = param.title, isOpen = param.isOpen, children = param.children;
    var ref = (0,react.useState)(!isOpen), hasCollapsed = ref[0], setHasCollapsed = ref[1];
    var isActive = !hasCollapsed;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionWrapper, {
        onClick: function() {
            return setHasCollapsed(function(prev) {
                return !prev;
            });
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        isActive: isActive,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            viewBox: "0 0 24 24",
                            focusable: "false",
                            className: "chakra-icon chakra-accordion__icon css-j2ph2z",
                            "aria-hidden": "true",
                            preserveAspectRatio: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "currentColor",
                                d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Collapse, {
                isOpen: isActive,
                duration: 300,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                        children: children
                    })
                })
            })
        ]
    });
}
var Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-90651da8-0"
})(_templateObject());
var TitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-90651da8-1"
})(_templateObject1());
var Icon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-90651da8-2"
})(_templateObject2(), function(p) {
    return p.isActive ? 180 : 0;
});
var Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-90651da8-3"
})(_templateObject3());
var AccordionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-90651da8-4"
})(_templateObject4(), (0,media/* media */.B)("<=desktop"));


/***/ }),

/***/ 73017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37946);
/* harmony import */ var utils_media__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13274);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 1.8rem;\n  opacity: 0.8;\n  line-height: 1.6;\n\n  ol,\n  ul {\n    list-style: none;\n    padding: 0rem;\n\n    li {\n      padding-left: 2rem;\n      position: relative;\n\n      & > * {\n        display: inline-block;\n        vertical-align: top;\n      }\n\n      &::before {\n        position: absolute;\n        content: 'L';\n        left: 0;\n        top: 0;\n        text-align: center;\n        color: rgb(var(--primary));\n        font-family: arial;\n        transform: scaleX(-1) rotate(-35deg);\n      }\n    }\n  }\n\n  table {\n    border-collapse: collapse;\n\n    table-layout: fixed;\n    border-spacing: 0;\n    border-radius: 5px;\n    border-collapse: separate;\n  }\n  th {\n    background: rgb(var(--textSecondary));\n  }\n\n  th,\n  td {\n    border: 1px solid rgb(var(--textSecondary));\n    padding: 1rem;\n  }\n\n  tr:nth-child(even) {\n    background: rgb(var(--textSecondary));\n  }\n\n  ",
        " {\n    font-size: 1.5rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var RichText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8ceca313-0"
})(_templateObject(), (0,utils_media__WEBPACK_IMPORTED_MODULE_1__/* .media */ .B)("<=desktop"));
/* harmony default export */ __webpack_exports__["Z"] = (RichText);


/***/ }),

/***/ 75319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ questions; }
/* harmony export */ });
var questions = [
    {
        id: 1,
        text: "Como funciona a Nossa Vaquinha? ",
        description: "A plataforma Nossa Vaquinha permite criar campanhas de arrecada\xe7\xe3o coletiva online atrav\xe9s de doa\xe7\xf5es. Os valores arrecadados s\xe3o transferidos  em seguran\xe7a para uma conta banc\xe1ria em nome do titular com o mesmo CPF, ou CNPJ cadastrados inicialmente na cria\xe7\xe3o da conta de benefici\xe1rio da plataforma Nossa Vaquinha."
    },
    {
        id: 2,
        text: "A plataforma Nossa Vaquinha \xe9 segura?",
        description: "O site \xe9 totalmente seguro. Todas as doa\xe7\xf5es s\xe3o protegidas por tecnologia de seguran\xe7a banc\xe1ria e s\xe3o transferidas diretamente para a conta-corrente do benefici\xe1rio da vaquinha, com o mesmo CPF ou CNPJ cadastrados inicialmente para cria\xe7\xe3o de uma conta na plataforma Nossa Vaquinha. <br></br> Nossa plataforma \xe9 100% segura porque utilizamos a Pagar.me, uma empresa do grupo STONE, a mesma tecnologia de seguran\xe7a que realiza os pagamentos de grandes lojas virtuais, como por exemplo, o Magazine Luiza. <br></br> A STONE possui a certifica\xe7\xe3o Payment Card Industry Data Security Standard (PCI-DSS), o que significa que todas as informa\xe7\xf5es s\xe3o criptografadas de ponta a ponta. <br><br>Al\xe9m disso, a Pagar.me \xe9 homologada como gateway pela Cielo, o que s\xf3 \xe9 concedido a empresas que seguem todas as normas de seguran\xe7a do PCI."
    },
    {
        id: 3,
        text: "Existem custos para se criar uma vaquinha? ",
        description: "Voc\xea usu\xe1rio, benefici\xe1rio da campanha, n\xe3o tem nenhum custo para personalizar o seu site com todos os recursos. <br/><br/> Para os benefici\xe1rios que N\xc3O s\xe3o m\xe3es \xe9 descontada uma tarifa de R$1,00 (um real) por doa\xe7\xe3o. Se n\xe3o houver doa\xe7\xe3o, n\xe3o haver\xe1 nenhum custo. <br><br>J\xe1 para as m\xe3es e OSC (entidades beneficentes ou empresas do Terceiro Setor) n\xe3o existem custos de cria\xe7\xe3o de campanha e n\xe3o h\xe1 desconto sobre doa\xe7\xf5es. "
    },
    {
        id: 4,
        text: "Qual a tarifa de saque dos valores recebidos nas doa\xe7\xf5es?",
        description: "Para todos os usu\xe1rios, incluindo m\xe3es e OSC, existe uma tarifa que se refere ao servi\xe7o de transfer\xeancia banc\xe1ria no valor R$ 3,67 por cada resgate (saque) realizado. O valor de R$ 3,67 N\xc3O \xe9 cobrado sobre cada doa\xe7\xe3o recebida e sim por cada resgate dos valores dispon\xedveis. <br><br> Dica: Orientamos que o benefici\xe1rio aguarde receber todas as doa\xe7\xf5es para que se pague uma \xfanica vez o valor de R$ 3,67 por todo o valor arrecadado. "
    },
    {
        id: 5,
        text: "Por quanto tempo a campanha ficar\xe1 no ar? ",
        description: "O site de sua campanha ficar\xe1 no ar por at\xe9 1 (um) ano (12 meses), sem nenhum custo adicional por isso. Ao final de 1 (um) ano, a campanha sair\xe1 do ar."
    },
    {
        id: 6,
        text: "Quais s\xe3o as taxas de servi\xe7os para quem realiza doa\xe7\xf5es?",
        description: "Para os doadores h\xe1 uma taxa de <strong>6,5%</strong> de acr\xe9scimo sobre o valor a ser doado. Este valor aparece em separado e fica vis\xedvel ao doador como “taxa de servi\xe7os”, antes da confirma\xe7\xe3o do pagamento. <br></br> Entendemos que n\xe3o faz sentido descontarmos do benefici\xe1rio da vaquinha as taxas de servi\xe7os, pois quem faz uma vaquinha precisa de toda a ajuda poss\xedvel. <br></br> A Nossa Vaquinha inovou o mercado de vaquinhas ao cobrar taxa zero para benefici\xe1rios que s\xe3o m\xe3es ou entidades beneficentes. <br></br> Ao cobrarmos a taxa de 6,5% do doador, este custo fica dilu\xeddo em muitas pessoas que t\xeam condi\xe7\xf5es de ajudar. Exemplo, para uma doa\xe7\xe3o de R$10,00, a taxa para o doador acresce apenas R$0,70 centavos na doa\xe7\xe3o  totalizando R$10,70. Portanto, a m\xe3e benefici\xe1ria receber\xe1 R$10,00 livre de taxas e impostos. <br></br> Agora vamos supor que uma campanha tenha arrecadado 1.000 doa\xe7\xf5es de R$10,00 cada, totalizando 10 mil reais no final da campanha. Em todos os outros modelos de vaquinha que existem no mercado, a m\xe3e benefici\xe1ria da vaquinha teria que pagar sozinha algo em torno de R$700,00 referente a taxas de opera\xe7\xf5es, recebendo l\xedquidos apenas R$9.300,00. Em nosso modelo, o benefici\xe1rio receber\xe1 R$10.000,00 l\xedquidos, livre de taxas e impostos e pagar\xe1 apenas R$3,67 (tr\xeas reais e sessenta e sete centavos), que \xe9 a tarifa de saque. Isto porque a Nossa Vaquinha j\xe1 recolheu em cada doa\xe7\xe3o as tarifas e impostos obrigat\xf3rios dilu\xeddos em cada doador, com um m\xednimo de acr\xe9scimo."
    },
    {
        id: 7,
        text: "Para que se destinam as taxas de servi\xe7os? ",
        description: "A taxa de servi\xe7os \xe9 essencial para o funcionamento da plataforma. S\xe3o custos de servidor, tarifas banc\xe1rias, sistema de seguran\xe7a, sistema antifraude, impostos e taxa administrativa, equipes de desenvolvimento, manuten\xe7\xe3o e suporte ao usu\xe1rio da Nossa Vaquinha. "
    },
    {
        id: 8,
        text: "Quanto paga de tarifas um benefici\xe1rio que n\xe3o \xe9 m\xe3e e n\xe3o \xe9 OSC?",
        description: "N\xe3o sendo uma m\xe3e ou OSC  (entidades beneficentes, Terceiro Setor, ONG’s, etc.), o benenefici\xe1rio pagar\xe1 R$ 1,00 (Um real) por doa\xe7\xe3o, independentemente do valor valor doa\xe7\xe3o. Pagar\xe1 tamb\xe9m uma tarifa de saque no valor de R$ 3,67, a qual sugerimos pagar uma \xfanica vez, desde que aguarde receber todas as doa\xe7\xf5es para que se pague essa tarifa uma \xfanica vez."
    },
    {
        id: 9,
        text: "Por que solicitam o meu CPF para cadastro inicial?",
        description: "O CPF \xe9 necess\xe1rio para que a Pagar.me, empresa do Grupo Stone, respons\xe1vel pela seguran\xe7a e gest\xe3o financeira, possa garantir que a quantia em dinheiro das doa\xe7\xf5es sejam transferidas para uma conta corrente cadastrada somente em seu CPF. Esta \xe9 uma norma de seguran\xe7a autom\xe1tica da Pagar.me, para impedir que o resgate da quantia seja feito por terceiros. "
    },
    {
        id: 10,
        text: "Como funciona a solicita\xe7\xe3o de resgate e quais s\xe3o os prazos para libera\xe7\xe3o dos valores da doa\xe7\xe3o recebida?",
        description: "O resgate somente ser\xe1 permitido em seu PAINEL FINANCEIRO quando houver confirma\xe7\xe3o de pagamento do presente recebido e quando for cumprido o prazo para libera\xe7\xe3o. Os valores liberados para o resgate ficar\xe3o vis\xedveis no campo: “Saldo Dispon\xedvel para Resgate”.<br></br> Com rela\xe7\xe3o aos prazos, segue abaixo: <br></br> Cart\xe3o de cr\xe9dito: libera\xe7\xe3o entre 30 dias corridos (m\xednimo) e 33 dias corridos (m\xe1ximo), a partir da data da compra do presente.<br></br>PIX: libera\xe7\xe3o em alguns minutos ou at\xe9 24h a partir do pagamento. <br><br> Boleto: libera\xe7\xe3o entre 2 dias \xfateis (m\xednimo) e 4 dias \xfateis (m\xe1ximo), a partir da data do pagamento do boleto efetivado pelo comprador.  <br></br>Aten\xe7\xe3o: Em seu painel de INFORMA\xc7\xd5ES FINANCEIRAS, voc\xea poder\xe1 consultar o seu Saldo dispon\xedvel para resgate e os valores pendentes de libera\xe7\xe3o de cada presente foi comprado. Por\xe9m, a Nossa Vaquinha informa apenas quais doa\xe7\xf5es foram conclu\xeddas e est\xe3o aguardando prazo de libera\xe7\xe3o. Ap\xf3s conclu\xeddo o prazo para libera\xe7\xe3o das doa\xe7\xf5es, aparecer\xe1 no painel o valor dispon\xedvel para resgate. Ent\xe3o, o usu\xe1rio dever\xe1 clicar em: RESGATAR.  "
    },
    {
        id: 11,
        text: "Quais s\xe3o os servi\xe7os administrativos prestados pela plataforma Nossa Vaquinha e qual o compromisso da empresa Pagar.me? ",
        description: "\xc9 de responsabilidade da Nossa Vaquinha cuidar de custos administrativos, que s\xe3o: impostos, equipe de tecnologia e desenvolvimento, equipe de cria\xe7\xe3o art\xedstica e equipes de comunica\xe7\xe3o nas redes sociais e suporte ao usu\xe1rio. A Pagar.me, empresa do grupo STONE, \xe9 respons\xe1vel pela seguran\xe7a, contabilidade e gest\xe3o financeira dos presentes recebidos at\xe9 o momento da transfer\xeancia para a conta corrente do usu\xe1rio criador do evento.  "
    },
    {
        id: 12,
        text: "Eu j\xe1 recebi doa\xe7\xf5es, por\xe9m  gostaria de alterar o nome e CPF para receber os valores em conta corrente de outra pessoa. Isso \xe9 poss\xedvel?",
        description: "Em virtude da seguran\xe7a exigida pela operadora Pagar.me, n\xe3o \xe9 poss\xedvel alterar o CPF, ou seja, n\xe3o \xe9 poss\xedvel alterar o titular da conta que ir\xe1 receber os valores de doa\xe7\xf5es j\xe1 pagas por seus doadores. Esta  norma de seguran\xe7a \xe9 importante para impedir que seu resgate seja feito por terceiros. <br></br> Caso voc\xea ainda n\xe3o tenha compartilhado o site de sua campanha com seus convidados, e somente neste caso, voc\xea queira cadastrar outro CPF, deve-se come\xe7ar tudo do zero. Ou seja: criar uma nova conta, com um novo CPF, novo email e senha na Nossa Vaquinha e criar uma nova campanha. Para demais quest\xf5es relacionadas a este tema, favor contatar a equipe de suporte. Teremos prazer em te ajudar: contato@nossavaquinha.com.br"
    },
    {
        id: 13,
        text: "\xc9 poss\xedvel alterar os dados banc\xe1rios para recebimento do valor/dinheiro da campanha?",
        description: "Sim, por\xe9m o novo banco a ser cadastrado dever\xe1 necessariamente estar em nome do CPF ou CNPJ, previamente cadastrado na Nossa Vaquinha. N\xe3o \xe9 poss\xedvel alterar o CPF ou CNPJ cadastrado em virtude da seguran\xe7a exigida pela operadora PAGAR.ME. Esta norma de seguran\xe7a \xe9 para impedir que seu resgate seja feito por terceiros."
    },
    {
        id: 14,
        text: "Como \xe9 realizada a transfer\xeancia banc\xe1ria dos valores recebidos?",
        description: "O dono do evento ir\xe1 visualizar em seu Painel Financeiro o valor dispon\xedvel para resgate e informar\xe1 os dados de ag\xeancia e conta para transfer\xeancia. Importante: a transfer\xeancia banc\xe1ria ocorrer\xe1 apenas para uma conta banc\xe1ria do mesmo CPF informado no momento do cadastro inicial do perfil de usu\xe1rio no site Nossa Vaquinha."
    },
    {
        id: 15,
        text: "Eu posso criar mais de uma campanha com a minha mesma conta? ",
        description: "Sim. Para criar um novo evento, basta selecionar a op\xe7\xe3o “Criar novo evento” em seu painel de controle (home do usu\xe1rio) ap\xf3s realizar o login."
    },
    {
        id: 16,
        text: "At\xe9 quando \xe9 poss\xedvel doa\xe7\xf5es em uma campanha?",
        description: "Enquanto a p\xe1gina estiver no ar, ou seja, no per\xedodo de 1 (um) ano, ser\xe1 poss\xedvel receber doa\xe7\xf5es. Importante lembrar que o benefici\xe1rio poder\xe1 sacar valores de um evento em espec\xedfico em at\xe9 1 (um) ano ap\xf3s a data de libera\xe7\xe3o do valor de um presente em espec\xedfico e desde que o perfil esteja ativo em nosso banco de dados."
    },
    {
        id: 17,
        text: "Qual o prazo para solicitar transfer\xeancia de valores dos presentes recebidos e liberados para saque? ",
        description: "Ap\xf3s a confirma\xe7\xe3o de pagamento e o prazo de libera\xe7\xe3o do valor para saque de um presente recebido, o prazo para realizar o resgate deste presente convertido em dinheiro \xe9 de 365 dias corridos, desde que o usu\xe1rio n\xe3o tenha solicitado exclus\xe3o de sua conta no site da Nossa Vaquinha."
    },
    {
        id: 18,
        text: "\xc9 poss\xedvel alterar um e-mail cadastrado em minha conta? ",
        description: "Entre em contato conosco atrav\xe9s do e-mail contato@nossavaquinha.com.br e solicite a troca do email com a respectiva justificativa para an\xe1lise de seguran\xe7a do time de suporte."
    },
    {
        id: 19,
        text: "O site Nossa Vaquinha funciona para quem mora fora do Brasil? ",
        description: "Para quem realiza o evento ser\xe1 necess\xe1rio informar um CPF brasileiro e uma conta corrente em um banco brasileiro com o mesmo CPF para poder receber eventuais valores de doa\xe7oes. Para quem ir\xe1 fazer uma doa\xe7\xe3o, e mora fora do Brasil, basta ter um cart\xe3o de cr\xe9dito internacional ou pagar no pix atrav\xe9s de uma conta banc\xe1ria nacional."
    },
    {
        id: 20,
        text: "Como excluir uma campanha na Nossa Vaquinha?",
        description: "Para excluir uma campanha basta entrar no site com seu login e senha. Estamos na home de suas campanhas, passe o mouse sobre a campanha que deseja excluir e clique sobre o \xedcone da lixeira que aparecer\xe1 no canto superior direito da imagem que representa sua campanha. Se tiver dificuldade basta nos solicitar ajuda no e-mail contato@nossavaquinha.com.br "
    },
    {
        id: 21,
        text: "Como excluir minha conta em definitivo da plataforma Nossa Vaquinha?",
        description: "Para excluir sua conta definitivamente, solicite atrav\xe9s do e-mail contato@nossavaquinha.com.br. Importante considerar que, uma vez solicitada a exclus\xe3o da conta, ser\xe3o exclu\xeddas todas as suas campanhas e todo o acesso \xe0 sua p\xe1gina com os informes de doa\xe7\xf5es recebidas. Importante checar antes de dar in\xedcio a este processo se h\xe1 algum resgate financeiro autorizado, ou aguardando autoriza\xe7\xe3o, referente a doa\xe7\xf5es recebidas.  "
    },
    {
        id: 22,
        text: "O valor das doa\xe7\xf5es recebidas s\xe3o transferidas automaticamente para minha conta corrente?",
        description: "N\xe3o. Para realizar o resgate, o benefici\xe1rio da vaquinha dever\xe1 estar logado no site Nossa Vaquinha, acessar o Painel Financeiro e clicar no bot\xe3o “Resgatar”, se houver valor dispon\xedvel para resgate (saque). <br></br> Lembrando que para realizar o resgate, o usu\xe1rio dever\xe1 ter informado previamente os dados banc\xe1rios em nome da pessoa com o mesmo CPF cadastrado inicialmente na Nossa Vaquinha."
    },
    {
        id: 23,
        text: "Existe taxa para emiss\xe3o do boleto banc\xe1rio? ",
        description: "Sim, esta taxa \xe9 cobrada no valor de R$ 3,49 pelo banco emissor do boleto e n\xe3o recai sobre o benefici\xe1rio da vaquinha, ou seja, quem paga \xe9 o doador que solicita o boleto como forma de pagamento. Recomendamos o uso do PIX para que n\xe3o recaia taxa para o convidado."
    },
    {
        id: 24,
        text: "Houve uma falha na minha solicita\xe7\xe3o de resgate, o que fazer?",
        description: "Primeiro verifique se existe saldo dispon\xedvel para resgate.<br></br> Depois, verifique se voc\xea configurou corretamente todas as informa\xe7\xf5es do cadastro de sua conta corrente ou conta poupan\xe7a. Voc\xea acessa a configura\xe7\xe3o de cadastro no bot\xe3o amarelo que fica ao lado do bot\xe3o de Resgate (verde) em seu painel financeiro. <br></br> Uma vez na tela de configura\xe7\xf5es de cadastro de sua conta corrente, confira se todos os dados est\xe3o preenchidos corretamente, tais como: nome completo, nome do banco, n\xfamero da ag\xeancia (sem o d\xedgito) e n\xfamero da conta, com o d\xedgito da conta em campo separado. Por fim, verifique se todos os campos do seu endere\xe7o est\xe3o preenchidos corretamente para que voc\xea possa receber a nota fiscal dos servi\xe7os a Nossa Vaquinha. <br></br> O CPF, ou CNPJ, do titular desta conta banc\xe1ria deve ser o mesmo que se cadastrou no site da Nossa Vaquinha. Esta \xe9 uma norma de seguran\xe7a autom\xe1tica da Pagar.me, para impedir que seu resgate seja feito por terceiros. <br></br> Caso tudo isso n\xe3o resolva, pode ser que voc\xea tenha ficado um tempo sem conex\xe3o e o seu login tenha ca\xeddo. Basta, ent\xe3o, fechar o site do Nossa Vaquinha, para depois reabri-lo e fazer o login novamente. Repita a opera\xe7\xe3o de resgate em seu Painel de Financeiro. Se nada disso resolver, entre em contato com nossa equipe de suporte atrav\xe9s do contato@nossavaquinha.com.br Ser\xe1 um prazer te ajudar."
    },
    {
        id: 25,
        text: "Ap\xf3s solicitar o resgate, em quanto tempo o valor cair\xe1 na minha conta banc\xe1ria?",
        description: "O valor estar\xe1 em sua conta banc\xe1ria em alguns minutos, a depender do hor\xe1rio da solicita\xe7\xe3o, ou em at\xe9 24h de um dia \xfatil. "
    },
    {
        id: 26,
        text: "Como saber se um benefici\xe1rio recebeu minha doa\xe7\xe3o? ",
        description: "Transpar\xeancia \xe9 um princ\xedpio que n\xe3o abrimos m\xe3o. Tanto o benefici\xe1rio, como tamb\xe9m o doador, receber\xe1 um e-mail informando quando o pagamento da doa\xe7\xe3o for conclu\xedda, e o respectivo valor doado. Al\xe9m disso,  o valor da, quem a fez, o dia e hor\xe1rio, aparecer\xe3o automaticamente, tanto no painel financeiro do benefici\xe1rio, como no site p\xfablico da campanha, com o nome e a primeira letra do sobrenome de quem realizou a doa\xe7\xe3o. Caso o doador escolha aparecer de forma an\xf4nima, seu nome n\xe3o aparecer\xe1, mas aparecer\xe1 o valor e o hor\xe1rio da conclus\xe3o da doa\xe7\xe3o."
    },
    {
        id: 27,
        text: "O meu resgate falhou e fui cobrado pela taxa de saque mesmo assim, o que aconteceu?",
        description: "A Pagar.me cobra uma taxa de R$ 3,67 pelo servi\xe7o de resgate, mesmo que o resgate venha a falhar por erro no cadastro feito pelo usu\xe1rio. A Pagar.me justifica essa cobran\xe7a por haver necessidade de an\xe1lise por sua equipe para verificar o erro do usu\xe1rio nos dados banc\xe1rios. <br></br> Por isso, recomendamos o m\xe1ximo de cuidado ao preencher todos os campos do cadastro banc\xe1rio, antes de solicitar o seu resgate. Para orienta\xe7\xf5es clique em Leia-me que fica no formul\xe1rio de cadastro dos dados banc\xe1rios, o qual voc\xea acessa no bot\xe3o amarelo dentro do seu Painel Financeiro. <br></br> Se surgir alguma d\xfavida na hora de preencher o cadastro banc\xe1rio, entre em contato com o nosso suporte: contato@nossavaquinha.com.br."
    },
    {
        id: 28,
        text: "Selo de Verifica\xe7\xe3o na Nossa Vaquinha",
        description: "<b>O que \xe9 o selo de verifica\xe7\xe3o?</b><br />O selo de verifica\xe7\xe3o \xe9 um recurso opcional oferecido pela plataforma Nossa Vaquinha. Ele tem como objetivo conferir mais credibilidade e transpar\xeancia \xe0s campanhas, aumentando a confian\xe7a dos doadores e, consequentemente, a visibilidade da campanha.<br /><br /><b>Ter o selo de verifica\xe7\xe3o \xe9 obrigat\xf3rio?</b><br />N\xe3o. O selo \xe9 opcional. Todas as campanhas podem ser criadas e divulgadas normalmente na plataforma, mesmo sem o selo. No entanto, campanhas verificadas podem ser destacadas no site ou nas redes sociais da Nossa Vaquinha, a crit\xe9rio da equipe da plataforma.<br /><br /><b>Como solicitar o selo de verifica\xe7\xe3o?</b><br />Para solicitar o selo, o usu\xe1rio respons\xe1vel pela campanha deve enviar pelo e-mail contato@nossavaquinha.com.br os seguintes documentos: <ul><li>Laudo m\xe9dico (em PDF ou imagem), quando a campanha tiver finalidade de sa\xfade;</li><li>Documento oficial com foto e CPF, como RG ou CNH.</li></ul><b>Quem analisa os documentos enviados?</b><br />A equipe da Nossa Vaquinha realiza uma an\xe1lise interna dos documentos enviados para validar a veracidade das informa\xe7\xf5es e garantir que a campanha atenda aos crit\xe9rios b\xe1sicos de autenticidade.<br />Ap\xf3s a fase da verifica\xe7\xe3o dos documentos, uma pessoa da equipe poder\xe1 entrar em contato atrav\xe9s do telefone informado na cria\xe7\xe3o da conta, para uma entrevista.<br /><br /><b>A plataforma garante a veracidade das campanhas verificadas?</b><br />A an\xe1lise tem car\xe1ter documental e n\xe3o implica corresponsabilidade da plataforma. A veracidade do conte\xfado e a entrega do que for prometido pela campanha \xe9 de responsabilidade exclusiva do usu\xe1rio que a criou.<br /><br /><b>Quais os benef\xedcios de uma campanha verificada?</b><br />Campanhas com selo de verifica\xe7\xe3o tendem a:<ul><li>Receber mais doa\xe7\xf5es, por transmitirem maior seguran\xe7a;</li><li>Ter maior visibilidade na plataforma;</li><li>Ser consideradas para destaque em redes sociais ou na p\xe1gina inicial.</li>"
    }, 
];


/***/ }),

/***/ 62257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FaqVideosSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37946);
/* harmony import */ var components_Accordion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2597);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 3rem;\n	width: 100%;\n	max-width: 800px;\n	margin-left: auto;\n	margin-right: auto;\n	padding: 0 1rem;\n\n	@media (max-width: 768px) {\n		padding: 0 0.5rem;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  padding-top: 56.25%;\n  min-height: 200px;\n\n  iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n    border-radius: 8px;\n  }\n\n  @media (max-width: 768px) {\n    min-height: 250px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var videos = [
    {
        id: 1,
        title: "Clique aqui para assistir ao v\xeddeo tutorial",
        youtubeId: "EXcSf79PEgg"
    }, 
];
function FaqVideosSection() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
            children: videos.map(function(video) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    title: video.title,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(VideoContainer, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("iframe", {
                            src: "https://www.youtube.com/embed/".concat(video.youtubeId),
                            title: video.title,
                            frameBorder: "0",
                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                            allowFullScreen: true
                        })
                    })
                }, video.id);
            })
        })
    });
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e4d1ed20-0"
})(_templateObject());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e4d1ed20-1"
})(_templateObject1());
var VideoContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e4d1ed20-2"
})(_templateObject2());


/***/ })

}]);